import type { IMoodRecord } from '@shared/types';

export interface IGroupedMoodRecords {
  [monthKey: string]: IMoodRecord[];
}

/**
 * Group mood records by month.
 * @param moodRecords - Array of mood records.
 * @returns Object with month keys (YYYY-MM) and arrays of mood records.
 */
export const groupMoodRecordsByMonth = (moodRecords: IMoodRecord[]): IGroupedMoodRecords => {
  return moodRecords.reduce((acc, record) => {
    const monthKey = record.mood_date.slice(0, 7); // Extract YYYY-MM.
    if (!acc[monthKey]) {
      acc[monthKey] = [];
    }
    acc[monthKey].push(record);
    return acc;
  }, {} as IGroupedMoodRecords);
};

/**
 * Format month key to display format.
 * @param monthKey - Month key in YYYY-MM format.
 * @returns Formatted string like "August 2025".
 */
export const formatMonthKey = (monthKey: string): string => {
  const [year, month] = monthKey.split('-').map(Number);
  const date = new Date(parseInt(`${year || '0'}`, 10), parseInt(`${month || '0'}`, 10) - 1, 1);
  const monthName = date.toLocaleDateString('en-US', { month: 'long' });
  return `${monthName} ${year?.toString() || '0'}`;
};
